import { AllSkuResponseModel, SkuPercentagesResponseModel, SkuResponseModel,SkuDetailsResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DepartmentsDTO } from '../departments/dto/departments.dto';
import { GetValueAdditionDataBySkuCodesRequest } from './dto/get-valu-addition-data-by-sku-codes.request';
import { SkuCodesDTO } from './dto/sku-codes.dto';
import { SkuCodesRequest } from './dto/sku-codes.request';
import { SkuDataRequest } from './dto/sku-data-request';
import { SkuDetails } from './dto/sku_details.dto';
import { SkuCodesService } from './sku-codes.service';
import {CommonResponse } from '@gtpl/shared-models/masters';
import { request } from 'http';
import { UserRequestDto } from '@gtpl/shared-models/common-models';

@ApiTags('sku-codes')
@Controller('sku-codes')
export class SkuCodesController {
    constructor(
        private skuCodesService: SkuCodesService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }

    @ApiTags('')
    /**
     * create SkuCode
     * @param skuCodesDTO 
     * @param isUpdate 
     * @param request 
     */
    @Post('/createSkuCode')
    async createSkuCode(@Body() skuCodesDTO: SkuCodesDTO, isUpdate: boolean = false, @Req() request: Request): Promise<SkuResponseModel> {
        try {
            // console.log(skuCodesDTO);
            return await this.skuCodesService.createSkuCode(skuCodesDTO, false, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SkuResponseModel, error)
        }
    }
    /**
     * update SkuCode
     * @param skuCodesDTO 
     * @param request 
     */
    @Post('/updateSkuCode')
    async updateSkuCode(@Body() skuCodesDTO: SkuCodesDTO, @Req() request: Request): Promise<SkuResponseModel> {
        try {
            return await this.skuCodesService.createSkuCode(skuCodesDTO, true, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SkuResponseModel, error)
        }
    }
    /**
     * get all Sku Codes
     * @param request 
     */
    @Post('/getAllSkuCodes')
    async getAllSkuCodes(@Body() req?:UserRequestDto): Promise<AllSkuResponseModel> {
        try {
            return await this.skuCodesService.getAllSkuCodes(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllSkuResponseModel, error)
        }
    }

    @Post('/getAllActiveSkuCodes')
  async getAllActiveSkuCodes(@Req() request: Request): Promise<AllSkuResponseModel> {
      try {
          return await this.skuCodesService.getAllActiveSkuCodes();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllSkuResponseModel, error)
      }
  }
    /**
     * Activate or DeActivate Sku Codes
     * @param skuCodeReq 
     */
    @Post('/activateOrDeactivateSkuCode')
    async activateOrDeactivateSkuCode(@Body() skuCodeReq: SkuCodesRequest): Promise<SkuResponseModel> {
        try {
            return await this.skuCodesService.activateOrDeactivateSkuCode(skuCodeReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(SkuResponseModel, err);
        }
    }
    /**
     * 
     * @param skuCodeReq 
     * @returns 
     */
    @Post('/getValueAdditionDataBySkuCode')
    async getValueAdditionDataBySkuCode(@Body() skuCodeReq: GetValueAdditionDataBySkuCodesRequest) {
        try {
            return await this.skuCodesService.getValueAdditionDataBySkuCode(skuCodeReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

     @Post('/getSkuDataById')
    async getSkuDataById(@Body() skuCodeReq:SkuCodesRequest,@Req() request: Request): Promise<SkuResponseModel> {
        try {
        return await this.skuCodesService.getSkuDataById(skuCodeReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SkuResponseModel, error)
        }
    }

    @Post('/getYieldPercentages')
    async getYieldPercentages(@Body() Req:SkuDataRequest): Promise<SkuPercentagesResponseModel> {
        try {
        return await this.skuCodesService.getYieldPercentages(Req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SkuPercentagesResponseModel, error)
        }

    }
  
    @Post('/createSkuDetails')
    async createSkuDetails(@Body() SkuDetails:SkuDetails,@Req() request:Request ) : Promise<SkuDetailsResponseModel> {
        try {
        return await this.skuCodesService.createSkuDetails(SkuDetails,request)
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SkuDetailsResponseModel, error)
        }

    }

    @Post('/getSkuConversions')
    async getSkuConversions(@Body() req:SkuCodesRequest ) : Promise<CommonResponse> {
        try {
        return await this.skuCodesService.getSkuConversions(req)
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }

    }

    @Post('/getSkuCodeNamesForSkucodeId')
    async getSkuCodeNamesForSkucodeId(@Body() skuCodeReq: GetValueAdditionDataBySkuCodesRequest) {
        try {
            return await this.skuCodesService.getSkuCodeNamesForSkucodeId(skuCodeReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

}

